import { apiRequestGatewayFactory } from "../ApiRequestGatewayFactory";
export var GlobalConfig = {
    config: {
        anonymousApiUrl: "",
        siteID: "",
        apiVersion: "v2",
        operatorAuthTokenId: "",
        applicationType: 0,
        domainID: "0"
    }
};
let Instance;
function setGateway(gateway) {
    if (!Object.isFrozen(Instance) || Instance === undefined) {
        Instance = {
            Gateway: gateway
        };
        Object.freeze(Instance);
    }
    return Instance.Gateway;
}
export function init(config) {
    if (!Object.isFrozen(GlobalConfig)) {
        GlobalConfig.config = config;
        Object.freeze(GlobalConfig);
        setGateway(apiRequestGatewayFactory(GlobalConfig));
    }
    else {
        throw new Error("Already initiliazed");
    }
}
export function apiRequestGateway() {
    if (!Object.isFrozen(GlobalConfig) || Instance === undefined) {
        throw new Error("sb-authorization-lib is not initialized");
    }
    return Instance.Gateway;
}
;
//# sourceMappingURL=init.js.map